import { useTranslation } from "react-i18next";
import { Code2, TrendingUp, Users } from "lucide-react";

export default function Outcomes() {
  const { t } = useTranslation("landing");

  const cards = [
    {
      icon: Code2,
      title: t("outcomes.list.projects.title"),
      body: t("outcomes.list.projects.description"),
      bg: "bg-blue-50 text-blue-600",
    },
    {
      icon: TrendingUp,
      title: t("outcomes.list.acceptance.title"),
      body: t("outcomes.list.acceptance.description"),
      bg: "bg-emerald-50 text-emerald-600",
    },
    {
      icon: Users,
      title: t("outcomes.list.experience.title"),
      body: t("outcomes.list.experience.description"),
      bg: "bg-violet-50 text-violet-600",
    },
  ];

  return (
    <section className="bg-white py-24 w-full">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center w-full">
          <p className="label-eyebrow">{t("outcomes.tag", "WHY IT MATTERS")}</p>
          <h2 className="mt-3 text-4xl font-extrabold text-navy sm:text-5xl">{t("outcomes.title", "Outcomes That Set You Apart")}</h2>
        </div>

        <div className="mt-14 w-full grid grid-cols-1 gap-6 sm:grid-cols-3">
          {cards.map((c) => (
            <div
              key={c.title}
              className="w-full rounded-[2rem] border border-slate-100 bg-white p-8 shadow-soft transition-all hover:-translate-y-1.5 hover:shadow-card"
            >
              <span className={`inline-grid h-14 w-14 place-items-center rounded-2xl ${c.bg}`}>
                <c.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-6 text-2xl font-bold text-navy leading-tight">{c.title}</h3>
              <p className="mt-3 text-sm sm:text-base leading-relaxed text-slate-body">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
